import { cdnBaseUrl } from '@src/utils/constants';
import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";
import { getDefaultLanguage } from "@src/utils/getAxiosConfig";

const getDefaultLang = getDefaultLanguage();
let backGround;
console.log(getDefaultLang, "gdl");
if (getDefaultLang === "VI") {
  backGround =
    `https://${cdnBaseUrl}-cloudn.classplus.co/web/courseWebview/content/Purchased.svg`;
  // backGround = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH_B-bqbHdgkzvtgSJ_LfGGkT9fXPD27E7qQ&usqp=CAU'
} else if (getDefaultLang === "KO") {
  backGround =
    `https://${cdnBaseUrl}-cloudn.classplus.co/web/courseWebview/content/Purchased.svg`;
  // backGround = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyEF8D8hKPhnYX3AIERI4ViHk5k7WNtyDwJw&usqp=CAU'
} else {
  //en
  backGround =
    `https://${cdnBaseUrl}-cloudn.classplus.co/web/courseWebview/content/Purchased.svg`;
}

const PaidSummary = ({ installmentData = false, data }) => {
  const { t } = useTranslation();
  if (installmentData) {
    return (
      <div
        className={styles.PaidSummaryContainer}
        style={
          {
            // backgroundImage: `url(${backGround})`,
            // backgroundSize: 'inherit',
          }
        }
      >
        {installmentData.map((d, i) => (
          <div className={styles.PaidSummary} key={`${i}paid`}>
            <div
              className={
                i == 0
                  ? styles.PaidSummary__Left__AmountPaid
                  : styles.PaidSummary__Left__Date
              }
            >
              {d?.key}
            </div>
            <div
              className={
                i == 0
                  ? styles.PaidSummary__Right__Amount
                  : styles.PaidSummary__Right__Date
              }
              style={{ color: d?.value?.color }}
            >
              {d?.value?.text}
            </div>
          </div>
        ))}
      </div>
    );
  }
  if (data) {
    return (
      <div
        className={styles.PaidSummaryContainer}
        style={{
          // backgroundImage: `url(${backGround})`,
          // backgroundSize: 'inherit',
          padding: data?.hideAmount == 1 ? "28px 16px" : "16px",
        }}
      >
        {data?.hideAmount === 1 ? (
          ""
        ) : (
          <div className={styles.PaidSummary}>
            <div className={styles.PaidSummary__Left__AmountPaid}>
              {t(
                "components.tabs.overview.components.PaidSummary.amountPaid",
                "Amount paid"
              )}
            </div>
            <div className={styles.PaidSummary__Right__Amount}>
              {data?.amount}
            </div>
          </div>
        )}

        <div className={styles.PaidSummary}>
          <div className={styles.PaidSummary__Left__Date}>
            {t(
              "components.tabs.overview.components.PaidSummary.purchasedDate",
              "Purchased Date"
            )}
          </div>
          <div className={styles.PaidSummary__Right__Date}>
            {/* {new Date(data?.receiptDate)} */}
            {data?.receiptDate}
          </div>
        </div>
        {data?.purchasedTime ? (
          <div className={styles.PaidSummary}>
            <div className={styles.PaidSummary__Left__Date}>
              {t(
                "components.tabs.overview.components.PaidSummary.time",
                "Time"
              )}
            </div>
            <div className={styles.PaidSummary__Right__Date}>
              {data?.purchasedTime}
            </div>
          </div>
        ) : null}
        {data?.discountText ? (
          <div className={styles.PaidSummaryContainer__Saved}>
            {data?.discountText}
          </div>
        ) : null}
        <div
          style={{
            position: "absolute",
            // top: (courseDetails?.paymentSummary?.amount ? "5rem" : "0rem"),
            left: "38%",
            top: "16%",
          }}
        >
          <img src={`https://${cdnBaseUrl}-cloudn.classplus.co/web/courseWebview/content/SVGPurchased.svg`} />
          <p
            className={
              getDefaultLang === "KO"
                ? styles.PaidSummaryContainer__PurchasedStampKO
                : getDefaultLang === "VI"
                ? styles.PaidSummaryContainer__PurchasedStampVI
                : styles.PaidSummaryContainer__PurchasedStampEng
            }
          >
            {t(
              "components.Tabs.Overview.components.PricingSection.purchasedStamp",
              "PURCHASED"
            )}
          </p>
        </div>
      </div>
    );
  }
  return <div className={styles.PaidSummaryContainer}></div>;
};

export default React.memo(PaidSummary);
